import React, { useState, useEffect } from "react";
import { P_Props } from "./VideoForm.type";
import { Form, Field } from "react-final-form";
import { FormUtil, FormUIUtil, loadCallback, ImageUtil, VideoUploadUtil } from "../../../../../utils";
import { Loading, SimpleModalHeader, CategoryCard1 } from "../../../../components";
import { Grid, TextField, Switch, FormControlLabel, MenuItem, Select, OutlinedInput, Chip } from "@material-ui/core";
import { FORM_MODE, VIDEO_MODE, VideoOutputModel } from "../../../../../models";
import { UploadVideoIcon, UploadLinkIcon } from "../../../../icons";

const VideoFormPresenter: React.FC<P_Props> = (props) => {
  const [visibleVideoInput, setVisibleVideoInput] = useState<Boolean>(false);
  const [visibleLinkInput, setVisibleLinkInput] = useState<Boolean>(false);

  useEffect(() => {
    if (props.mode === FORM_MODE.EDIT)
      setVisibleLinkInput(true)
  }, [props.mode, props.fileUpload])

  let submit: any;

  const bindingDataToForm = (data: VideoOutputModel[]) => {
    const tempData: (VideoOutputModel & { categoryVideoId: string[]})[] = data.map((item) => {
      const ids: string[] = item.videoCategory.map((cate) => cate.categoryId);

      return { ...item, categoryVideoId: ids }; // categoryBlogId to form
    });

    const result = Object.assign(
      FormUtil.buildInitDataForm(tempData, [{ key: "title" }, { key: "description" }, { key: "categoryVideoId" }])
    );
    return result;

    // const transfomedData = data.reduce((result, item) => {
    //   return {
    //     ...result,
    //     ...item,
    //     [`title${item.languageId}`]: item.title,
    //     [`description${item.languageId}`]: item.description,
    //     [`categoryVideoId${item.languageId}`]: ""
    //   }
    // }, {})
    // return transfomedData;
  };

  return (
    <>
      <div className="video-form">
        <SimpleModalHeader
          title={
            props.mode === FORM_MODE.CREATE
              ? props.type === VIDEO_MODE.HOMEPAGE
                ? "Upload Video Homepage"
                : "Upload Video Resource"
              : props.type === VIDEO_MODE.RESOURCE
                ? "Edit Video Resource"
                : "Edit Video Homepage"
          }
          onClose={() => {
            props.onCancel();
          }}
        />
        <div className="video-form__divide">
          <div className="video-form__language">
            <h1>Language</h1>
            {props.languageData.map((lang) => {
              return (
                <CategoryCard1
                  key={lang.id}
                  name={lang.name}
                  picture={lang.image || undefined}
                  buildPictureSrc={ImageUtil.buildLanguageImgSrc}
                  onClick={() => {
                    props.onChangeLanguage(lang.id)
                  }}
                  selected={props.activeLanguageId === lang.id}
                  isAvatar={true}
                />
              );
            })}
          </div>

          <div className="video-form__container">
            {props.loading && <Loading />}
            {!props.loading && (
              <Form
                initialValues={
                  props.initData?.length
                    ? bindingDataToForm(props.initData)
                    : {}
                }
                initialValuesEqual={() => true}
                onSubmit={async (values, form) => {
                  props.onSubmit(values);
                }}
                render={({ handleSubmit, form, pristine }) => {
                  submit = handleSubmit;

                  return (
                    <form onSubmit={handleSubmit}>
                      <Grid container spacing={2}>
                        <Grid item xs={8}>
                          {props.languageData.map((lang) => {
                            return (
                              <div style={{ display: props.activeLanguageId === lang.id ? "flex" : "none" }} key={lang.id}>
                                <Field
                                  name={`title${lang.id}`}
                                  validate={lang.isPrimary
                                    ? FormUtil.Rule.required(
                                      "Title is required"
                                    )
                                    : undefined}
                                  subscription={{ touched: true, error: true, value: true }}
                                >
                                  {({ input, meta, ...rest }) => {
                                    return FormUIUtil.renderFormItem(
                                      "Video title",
                                      <TextField
                                        {...input}
                                        {...rest}
                                        fullWidth
                                        placeholder="Text input..."
                                        className="form-text-field"
                                        inputProps={{ className: "input" }}
                                        variant="outlined"
                                        onChange={(e) => input.onChange(e.target.value)}
                                        helperText={meta.touched ? meta.error : ""}
                                        error={meta.error && meta.touched}
                                      />
                                    );
                                  }}
                                </Field>
                              </div>
                            )
                          })}
                        </Grid>
                        <Grid item xs={4}>
                          <div style={{ display: (props.mode === FORM_MODE.CREATE && props.type === VIDEO_MODE.HOMEPAGE) ? "none" : "flex" }}>
                            {FormUIUtil.renderFormItem(
                              "Status",
                              <FormControlLabel
                                control={
                                  <Switch
                                    checked={props.videoStatus.status}
                                    onChange={(e) => {
                                      props.onChangeBannerStatus(e.target.checked);
                                    }}
                                    className="app-switch-box"
                                  />
                                }
                                label={
                                  <div className="form-label" style={{ marginBottom: 0 }}>
                                    Publish
                                  </div>
                                }
                              />, true
                            )}
                          </div>
                        </Grid>
                        <Grid item xs={12}>
                          {props.type === VIDEO_MODE.RESOURCE && props.languageData.map((lang) => {
                            return (
                              <div
                                key={lang.id}
                                style={{
                                  display: props.activeLanguageId === lang.id ? "flex" : "none",
                                }}
                              >
                                <Field name={`categoryVideoId${lang.id}`}>
                                  {({ input, meta, ...rest }) => {
                                    return FormUIUtil.renderFormItem(
                                      "Category",
                                      <Select
                                        {...input}
                                        {...rest}
                                        // native
                                        multiple
                                        value={[...input.value]}
                                        error={meta.error && meta.touched}
                                        fullWidth
                                        input={<OutlinedInput className="form-text-field" />}
                                        variant="outlined"
                                        renderValue={(selected: any) => {
                                          const cates = props.categories
                                            .filter((cate) => selected.includes(cate.id))
                                            .map((cate) => {
                                              return (
                                                <Chip
                                                  className="blog-form__box__select__chip"
                                                  key={cate.code}
                                                  label={cate.title}
                                                />
                                              );
                                            });
                                          return cates;
                                        }}
                                        className="form-select-field blog-form__box__select"
                                      >
                                        {props.categories.map((cate) => (
                                          <MenuItem key={cate.id} value={cate.id}>
                                            {cate.title}
                                          </MenuItem>
                                        ))}
                                      </Select>
                                    );
                                  }}
                                </Field>
                              </div>
                            );
                          })}
                        </Grid>
                        <Grid item xs={12}>
                          {props.languageData.map((lang) => {
                            return (
                              <div style={{ display: props.activeLanguageId === lang.id ? "flex" : "none" }} key={lang.id}>
                                <Field name={`description${lang.id}`}>
                                  {({ input, meta, ...rest }) => {
                                    return FormUIUtil.renderFormItem(
                                      "Description",
                                      <TextField
                                        {...input}
                                        {...rest}
                                        fullWidth
                                        placeholder="How would you describe this file?"
                                        className="form-text-field"
                                        inputProps={{ className: "input" }}
                                        variant="outlined"
                                        onChange={(e) => input.onChange(e.target.value)}
                                      />
                                    );
                                  }}
                                </Field>
                              </div>
                            )
                          })}
                        </Grid>
                        <Grid item xs={12}>
                          <div className="video-form--upload__body">
                            {(props.fileUpload || (props.mode === FORM_MODE.EDIT && props.fileUpload))
                              ? (
                                <div className="video-form--upload__body__uploaded">
                                  <video width="100%" height="240" controls>
                                    <source src={VideoUploadUtil.buildVideoSrc(props.fileUpload)} type="video/mp4" />
                                    <source src={VideoUploadUtil.buildVideoSrc(props.fileUpload)} type="video/ogg" />
                                    <source src={VideoUploadUtil.buildVideoSrc(props.fileUpload)} type="video/webm" />
                                    Your browser does not support the video tag.
                                  </video>
                                </div>
                              )
                              : (
                                <>
                                  <div className="video-form--upload__body__no-file"
                                    style={{ display: ((visibleVideoInput || visibleLinkInput) ? "none" : "flex") }}
                                  >
                                    <div className="upload-file__item" onClick={() => setVisibleVideoInput(true)}>
                                      <UploadVideoIcon size={[42, 39]} color="#6658F3" />
                                      <p className="upload-file__text">Upload A Video</p>
                                    </div>
                                    <div className="upload-file__item" onClick={() => setVisibleLinkInput(true)}>
                                      <UploadLinkIcon size={[35, 36]} color="#6658F3" />
                                      <p className="upload-file__text">Add Link Video</p>
                                    </div>
                                  </div>

                                  {/* Upload Link video */}
                                  <div className="video-form--upload__body__no-file"
                                    style={{ display: (visibleLinkInput ? "flex" : "none") }}
                                  >
                                    <Field
                                      name="linkVideo"
                                      validate={FormUtil.Rule.required(
                                        "Link is required"
                                      )}
                                      subscription={{ touched: true, error: true, value: true }}
                                    >
                                      {({ input, meta, ...rest }) => {
                                        return FormUIUtil.renderFormItem(
                                          "",
                                          <TextField
                                            {...input}
                                            {...rest}
                                            style={{ width: "48rem", margin: "0 5rem" }}
                                            placeholder="Type or paste link"
                                            className="form-text-field"
                                            inputProps={{ className: "input" }}
                                            variant="outlined"
                                            onChange={(e) => input.onChange(e.target.value)}
                                            helperText={meta.touched ? meta.error : ""}
                                            error={meta.error && meta.touched}
                                          />
                                        );
                                      }}
                                    </Field>
                                  </div>

                                  <div className="video-form--upload__body__no-file"
                                    style={{ display: (visibleVideoInput ? "flex" : "none") }}
                                  >
                                    <UploadVideoIcon size={[42, 39]} color="#6658F3" />
                                    <p className="upload-file__text">Upload A Video</p>
                                    <input accept="video/*" type="file" id="input-video" onChange={(e) => props.handleFileUpload(e)} />
                                  </div>
                                </>
                              )}
                          </div>
                        </Grid>
                      </Grid>
                    </form>
                  );
                }}
              />
            )}
          </div>
        </div>

        <div className="video-form--footer">
          <div className="video-form--footer__text">
            <b>Complete the upload</b><br />
            or change other videos
          </div>
          <div className="video-form__actions">
            <button
              className={props.type === VIDEO_MODE.RESOURCE ? "btn save" : "btn cancel"}
              type="submit"
              style={{
                display: ((props.mode === FORM_MODE.CREATE && props.type === VIDEO_MODE.HOMEPAGE) || props.type === VIDEO_MODE.RESOURCE)
                  ? "flex" : "none"
              }}
              onClick={(e) => {
                loadCallback(submit, e);
              }}
            >
              Save
            </button>
            <button
              type="submit"
              className="btn save"
              style={{ display: (props.mode === FORM_MODE.CREATE && props.type === VIDEO_MODE.HOMEPAGE) ? "flex" : "none" }}
              onClick={(e) => {
                loadCallback(submit, e);
              }}
            >
              Save and Publish
            </button>
            <button
              className="btn delete"
              style={{ display: (props.mode === FORM_MODE.EDIT && props.type === VIDEO_MODE.HOMEPAGE) ? "flex" : "none" }}
              onClick={(e) => {
                e.preventDefault();
                if (props.videoCode) {
                  props.onDeleteVideo(props.videoCode);
                }
              }}
            >
              Delete
            </button>
            <button
              type="submit"
              className="btn save"
              style={{ display: (props.mode === FORM_MODE.EDIT && props.type === VIDEO_MODE.HOMEPAGE) ? "flex" : "none" }}
              onClick={(e) => {
                loadCallback(submit, e);
              }}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default VideoFormPresenter;
